import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
export const DocumentBlockView = memo(({ block }) => {
    const label = block.title || "Document";
    return (_jsx("div", { className: "card-content", children: _jsx("span", { className: "light-text", children: label }) }));
});
